<template>
  <div class="fileList">
    <div v-if="deleting && !working" class="deleteDialog">
      <p>
        {{ i18n().remove.prompt(deleting) }}
      </p>
      <div class="yesno">
        <span v-on:click="confirmDelete"
              class="btn mdl-button mdl-js-button mdl-button--raised mdl-button--accent">{{ i18n().remove.yes }}</span>
        <span v-on:click="cancelDelete"
              class="btn mdl-button mdl-js-button mdl-button--raised mdl-button--colored">{{ i18n().remove.no }}</span>
      </div>
    </div>
    <div v-if="fileList && !deleting && !working" class="list">
      <div v-for="(file, index) in fileList" class="file" v-on:click="select(file)"
           v-bind:class="{ selected: selected == file }">
        <i class="material-icons">insert_drive_file</i>
        <span class="name" v-if="renaming != file">{{ file.name }}</span>
        <span class="buttons" v-if="!renaming && !deleting">
          <span class="btn" v-on:click="remove(file)"><i class="material-icons">delete_forever</i></span>
          <span class="btn" v-on:click="rename(file)"><i class="material-icons">create</i></span>
        </span>

        <span class="rename" v-if="renaming == file">
          <input type="text" v-model="newName">
        </span>
        <span class="buttons" v-if="renaming == file">
          <span class="btn" v-on:click="finishRename"><i class="material-icons">done</i></span>
        </span>
      </div>
    </div>
    <div v-show="!fileList && !working" class="loading">
      <div class="mdl-spinner mdl-js-spinner is-active"></div>
      <p>{{ i18n().loading }}</p>
    </div>
    <div v-show="working" class="working">
      <div class="mdl-spinner mdl-js-spinner is-active"></div>
    </div>
  </div>
</template>

<script>
  import api from "api"
  import i18n from "i18n"

  export default {
    name: 'file-list',
    props: {
      contentType: {
        type: String,
        default: function () {
          return "view"
        }
      }
    },
    data () {
      return {
        fileList: null,
        working: false,
        selected: null,
        renaming: null,
        deleting: null,
        newName: ""
      }
    },
    methods: {
      i18n() { return i18n().save.list },
      select(file) {
        if(this.selected!=file) {
          this.renaming = null
        }
        this.selected = file
        this.$emit('selected', file)
      },
      remove(file) {
        this.deleting = file
      },
      rename(file) {
        this.newName = file.name
        this.renaming = file
      },
      finishRename() {
        this.working = true
        api.request(['save','rename'], this.contentType, this.renaming.name, this.newName).then(
          done => {
            this.renaming.name = this.newName
            this.renaming = null
            this.working = false
          }
        )
      },
      confirmDelete() {
        this.working = true
        api.request(['save','remove'], this.contentType, this.deleting.name).then(
          done => {
            this.deleting = null
            this.working = false
          }
        )
      },
      cancelDelete() {
        this.deleting = null
      }
    },
    created() {
      this.observable = api.observable(['save', 'list', this.contentType])
      this.observable.bindProperty(this, "fileList")
    },
    beforeDestroy() {
      this.observable.unbindProperty(this, "fileList")
    },
    updated () {
      componentHandler.upgradeAllRegistered()
    },
    mounted () {
      componentHandler.upgradeAllRegistered()
    }
  }
</script>

<style scoped>
  .fileList .list {
  }

  .loading {
    margin-top: 20px;
    text-align: center;
  }

  .file {
    position: relative;
    display: block;
    box-sizing: border-box;
    width: 100%;
    padding: 3px;
    line-height: 2em;
    cursor: pointer;
    font-weight: 300;
  }
  .file i {
    display: inline-block;
    vertical-align: middle;
  }
  .file .name {
    font-size: 1.23em;
    display: inline-block;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .file:hover {
    color: black;
  }
  .file:hover .name {
    text-decoration: underline;
  }

  .file.selected {
    background: #00bcd4;
    color: #000000;
  }
  .file.selected:hover {
    background: #00c1d8;
    color: #000000;
  }

  .file .buttons {
    float: right;
  }
  .file .buttons .btn {
    display: inline-block;
    border: none;
    border-radius: 200px;
    background: white;
    width: 28px;
    height: 28px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
  }
  .rename {
    position: relative;
    display: block;
    position: absolute;
    left: 32px;
    right: 32px;
    width: auto;
    height: 100%;
    top: 0;
  }
  .file input {
    border: 0;
    background: none;
    font-size: 1.23em;
    padding: 0;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .deleteDialog {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .deleteDialog p {
    font-size: 1.23em;
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// FileList.vue?820ded3a